import React, { useState, useEffect } from 'react';
import { intersection } from 'lodash';
import { navigate, useLocation, Link } from '@reach/router';
import './Navbar.scss';
import env, { SiteId } from '@/env';
import { getWebAppInfo } from '@/utils';
import { Paths } from '@/pages/routers';
import AuthDropdown from '@/containers/AuthDropdown/AuthDropdown';
import Button from '@/components/Button/Button';
import IconUser from '@/assets/icons/user-black.svg';
import { menusOBD, menusDakko } from './Navbar.data';

interface NavbarProps {
  params?: { [key: string]: string };
  renderLargeShiftLayout?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ params, renderLargeShiftLayout }) => {
  const webApp = getWebAppInfo(env.siteId);
  const webAppData = {
    [SiteId.Obd]: {
      menus: menusOBD,
    },
    [SiteId.DakkoHub]: {
      menus: menusDakko,
    },
  };
  const { pathname } = useLocation();
  const [activeMenu, setActiveMenu] = useState<string>('');
  const [activeMobileMenu, setActiveMobileMenu] = useState<boolean>(false);
  const { menus } = webAppData[env.siteId as keyof typeof webAppData];

  const handleClickMenu = (menuLabel: string, menuUrl?: string) => {
    setActiveMobileMenu(false);
    menuUrl && navigate(menuUrl, { state: { prevPath: pathname, isRefresh: true } });
  };

  const toggleMobileMenu = () => {
    setActiveMobileMenu(!activeMobileMenu);
  };

  const goToLogin = () => {
    navigate(`${Paths.Auth}${Paths.Login}`);
  };
  const goToRegister = () => {
    navigate(`${Paths.Auth}${Paths.Register}`);
  };

  useEffect(() => {
    if (renderLargeShiftLayout) {
      const paramKeys = params ? Object.keys(params) : [];
      const menuShouldActive = menus.find((menu) => {
        return (
          intersection(
            [pathname, `/${pathname.split('/')[1]}`],
            [menu.url, menu.oldUrl, `${menu.url}/`, `${menu.oldUrl}/`]
          ).length > 0 || menu.params.some((param) => paramKeys.includes(param))
        );
      });
      setActiveMenu(menuShouldActive?.label ?? '');
    }
  }, [pathname, params, menus, renderLargeShiftLayout]);

  return (
    <div className="Navbar">
      <Link className="Navbar-logo" to={Paths.Home}>
        <img src={webApp.mainLogo} alt={webApp.siteName} />
      </Link>
      <div className={`Navbar-mobileMenuWrapper ${activeMobileMenu && 'active'}`}>
        <div className="Navbar-mobileMenuWrapper-close" onClick={toggleMobileMenu}>
          <span>X</span>
        </div>
        <ul className="Navbar-menus">
          <div className="Navbar-menus-wrapper">
            {menus.map((menu) => (
              <Link
                onClick={() => menu.clickable && handleClickMenu(menu.label, menu.url)}
                key={menu.label}
                to={menu.url}
                state={{ prevPath: pathname, isRefresh: true }}
              >
                <li
                  className={`Navbar-menus-menu ${activeMenu === menu.label && 'active'}`}
                  onClick={() => menu.clickable && handleClickMenu(menu.label, menu.url)}
                >
                  <span className="Navbar-menus-menu-text">{menu.label}</span>
                </li>
              </Link>
            ))}
          </div>
          <div className="Navbar-auth">
            <AuthDropdown
              iconUser={IconUser}
              textColor="#000000"
              componentNotLoginYet={
                // <div className="Navbar-logout">
                //   <span>Login</span>
                // </div>

                // eslint-disable-next-line react/jsx-wrap-multilines
                <div className="Navbar-auth-button">
                  <Button
                    onClick={() => goToLogin()}
                    className="Navbar-logout"
                    type="button"
                    label="LOGIN"
                    color="primary-invert"
                  />
                  <Button
                    onClick={() => goToRegister()}
                    className="Navbar-logout register"
                    type="button"
                    label="REGISTER"
                    color="primary-invert"
                  />
                </div>
              }
            />
          </div>
        </ul>
      </div>
      <div className="Navbar-burger" onClick={toggleMobileMenu}>
        <div className="Navbar-burger-center" />
      </div>
    </div>
  );
};

export default Navbar;
